import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="container max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white bg-opacity-90 shadow-lg rounded-lg p-6 mb-6">
        <div className="flex justify-between items-center mb-6 border-b pb-4">
          <h1 className="text-2xl font-bold text-gray-800">Privacy Policy</h1>
          <Link to="/" className="text-orange-500 hover:text-orange-600 transition-colors">
            &larr; Back to App
          </Link>
        </div>

        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Introduction</h2>
            <p>
              This Privacy Policy describes how EOS Yes Bot ("we", "our", or "us") collects, uses, and discloses your information when you use our application.
              We are committed to protecting your privacy and personal information. Please read this Privacy Policy carefully to understand our practices.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Information We Collect</h2>
            <p className="mb-3">We may collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Account Information:</strong> When you create an account, we collect your name, email address, and other details necessary for account creation.</li>
              <li><strong>Company Information:</strong> Information about your company, industry, size, mission, and related details that you provide.</li>
              <li><strong>Documents and Files:</strong> Documents that you upload for your company profile.</li>
              <li><strong>Usage Information:</strong> Information about how you use the application, including chat interactions and feature usage.</li>
              <li><strong>Calendar Information:</strong> If you connect Google Calendar, we access calendar event information when explicitly requested in chat.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">How We Use Your Information</h2>
            <p className="mb-3">We use the collected information for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide and maintain our application</li>
              <li>To personalize your experience</li>
              <li>To improve our application and develop new features</li>
              <li>To respond to your inquiries and provide support</li>
              <li>To communicate with you about updates and changes</li>
              <li>To analyze usage patterns and optimize performance</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Data Sharing and Disclosure</h2>
            <p className="mb-3">We may share your information in the following circumstances:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Service Providers:</strong> We may share information with third-party vendors and service providers that perform services on our behalf.</li>
              <li><strong>Compliance with Laws:</strong> We may disclose information if required to do so by law or in response to valid requests by public authorities.</li>
              <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, financing, or acquisition of all or a portion of our business.</li>
              <li><strong>With Your Consent:</strong> We may share information with your consent or at your direction.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Data Security</h2>
            <p>
              We implement appropriate security measures to protect against unauthorized access, alteration, disclosure, or destruction of your data.
              However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Your Rights</h2>
            <p className="mb-3">Depending on your location, you may have certain rights regarding your personal information, including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>The right to access the personal information we hold about you</li>
              <li>The right to request correction or deletion of your personal information</li>
              <li>The right to restrict or object to certain processing of your data</li>
              <li>The right to data portability</li>
              <li>The right to withdraw consent at any time for processing based on consent</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page
              and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy, please contact us at support@upaway.dev.
            </p>
          </section>

          <div className="mt-8 pt-4 border-t text-sm text-gray-500 text-center">
            Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 